import { render, staticRenderFns } from "./RecipeHeader.vue?vue&type=template&id=925b1b7e&scoped=true"
import script from "./RecipeHeader.vue?vue&type=script&lang=js"
export * from "./RecipeHeader.vue?vue&type=script&lang=js"
import style0 from "./RecipeHeader.vue?vue&type=style&index=0&id=925b1b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925b1b7e",
  null
  
)

export default component.exports